// Centralized API endpoints configuration
export const API_ENDPOINTS = {
    // Voice Recordings
    VOICE_RECORDINGS: '/voice-recordings',
    VOICE_RECORDINGS_AUDIO: '/voice-recordings/audio',
    VOICE_RECORDINGS_AUTH: '/voice-recordings/authenticate',
};
